import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../lib/analytics";
import { captureReferralCodeFromUrl } from "../lib/referral";

const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  // page_view - reaproveita este componente porque ele ja e o unico ponto
  // montado uma vez so que reage a toda troca de rota da SPA (senao seria
  // preciso instrumentar cada pagina uma a uma).
  useEffect(() => {
    trackEvent("page_view");
  }, [pathname]);

  // Captura ?ref=<codigo> (T6, programa de indicacao) em qualquer pagina de
  // chegada, nao so na home - um link de indicacao pode apontar direto pra
  // /assinaturas, por exemplo.
  useEffect(() => {
    captureReferralCodeFromUrl(search);
  }, [search]);

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.replace("#", ""));
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }

    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
